<script setup>
  import { defineProps } from 'vue'
  import { ElMessage } from 'element-plus'
  import Clipboard from 'clipboard'

  const props = defineProps({ id: { type: [String, Number], required: true } })
  function copy(event) {
    const clipboard = new Clipboard(event.currentTarget, { text: () => String(props.id) })
    clipboard.on('success', () => {
      ElMessage.success('订阅ID已复制')
      clipboard.destroy()
    })
    clipboard.on('error', () => {
      ElMessage.error('复制失败，请手动复制')
      clipboard.destroy()
    })
    clipboard.onClick(event)
  }
</script>

<template>
  <span class="subscription-id">
    <span>{{ id }}</span>
    <el-button aria-label="复制订阅ID" size="small" type="text" @click="copy">复制</el-button>
  </span>
</template>

<style scoped>
  .subscription-id {
    display: inline-flex;
    align-items: center;
    gap: 12px;
  }
</style>
